/**
 * SideNavMenu.tsx — utvidbar meny i side-nav
 *
 * Ren React-komponent som erstatter cds-side-nav-menu.
 * Klikk toggler visning av underlenker.
 *
 * Props:
 * - title: meny-tittel
 * - children: SideNavMenuItem-komponenter
 */

import { useState } from 'react';
import styles from './side-nav-menu.module.css';

interface SideNavMenuProps {
  title: string;
  children: React.ReactNode;
}

export default function SideNavMenu({ title, children }: SideNavMenuProps) {
  const [expanded, setExpanded] = useState(false);

  return (
    <li className={styles.menu}>
      <button
        type="button"
        className={styles.toggle}
        aria-expanded={expanded}
        onClick={() => setExpanded(!expanded)}
      >
        <span className="side-nav-text">{title}</span>
        {/* side-nav-chevron: global klasse — skjules i kollapset rail-modus */}
        <span
          className={`side-nav-chevron ${expanded ? styles.chevronExpanded : styles.chevron}`}
        >
          ›
        </span>
      </button>
      {expanded && (
        /* side-nav-sub-items: global klasse — skjules i kollapset rail-modus */
        <ul className={`side-nav-sub-items ${styles.subItems}`}>
          {children}
        </ul>
      )}
    </li>
  );
}
